import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";

export default function NotFound() {
  return (
    <main id="contenu-principal" className="min-h-[60vh] flex items-center">
      <Seo title="Page introuvable | TN FOOD" description="La page demandée est introuvable." path="/404" noindex />
      <div className="container mx-auto px-4 max-w-2xl text-center py-24" data-testid="page-404">
        <p className="font-display text-8xl font-bold text-terracotta/30">404</p>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-encre mt-4">Cette page a glissé hors de la table…</h1>
        <p className="mt-4 text-taupe">La page que vous cherchez n'existe pas ou a été déplacée.</p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link to="/" data-testid="404-home" className="rounded-full bg-terracotta text-cream px-8 py-3 font-semibold transition-colors hover:bg-terracotta-dark">
            Retour à l'accueil
          </Link>
          <Link to="/carte" data-testid="404-carte" className="rounded-full border-2 border-terracotta text-terracotta px-8 py-3 font-semibold transition-colors hover:bg-terracotta hover:text-cream">
            Voir la carte
          </Link>
        </div>
      </div>
    </main>
  );
}
